<template>
    <div>
        <HeaderCard imageLogo="imageLogo" />
        <div class="py-3" v-if="user.npbu_id == null">
            <b-alert variant="warning" show class="text-center">
                <h5>Anda belum mendaftakan data Badan Usaha anda.</h5>
                <div>
                    Silahkan klik
                    <router-link to="/registrasi" class="font-weight-bold">Registrasi</router-link>,
                    untuk mendaftar.
                </div>
            </b-alert>
        </div>
        <div v-else>
            <!-- begin nav-tabs -->
            <b-tabs
                pills
                nav-class="px-2 py-1"
                nav-wrapper-class="bg-dark rounded text-white"
                content-class="card p-5 my-2"
                active-nav-item-class="bg-info"
            >
                <!-- begin tab -->
                <b-tab active>
                    <template slot="title">
                        <span class="d-sm-none">Tab 1</span>
                        <span class="d-sm-block d-none text-white"
                            >PROFIL BADAN USAHA</span
                        >
                    </template>
                    <div v-if="detailNpbu">

                        <b-table-simple outlined bordered small responsive class="mb-0">
                            <b-tbody>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td class="text-center align-middle">
                                                        <h5 class="font-weight-bold m-0">
                                                            PROFIL BADAN USAHA<br>
                                                            PENGELOLA KEKAYAAN DAERAH YANG DIPISAHKAN
                                                        </h5>
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <!--  -->
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td colspan="2" class="font-weight-bold">
                                                        <u>IDENTITAS BADAN USAHA</u>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        NPBUD
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        {{ detailNpbu.no_pokok }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Nama Badan Usaha
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        {{ detailNpbu.nama }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Nama Badan Usaha
                                                    </b-td>
                                                    <b-td class="font-weight-bold">
                                                        {{ detailNpbu.no_induk }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Alamat
                                                    </b-td>
                                                    <b-td class="">
                                                        {{ detailNpbu.alamat }}
                                                        <div v-if="detailNpbu.wilayah_kelurahan">
                                                            <div>
                                                                Kel. {{ detailNpbu.wilayah_kelurahan.nama }}
                                                            </div>
                                                            <div>
                                                                Kec. {{ detailNpbu.wilayah_kelurahan.wilayah_kecamatan.nama }}
                                                            </div>
                                                            <div>
                                                                {{ detailNpbu.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.nama }}
                                                            </div>
                                                            <div>
                                                                {{ detailNpbu.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi.nama }}
                                                            </div>
                                                            <div>
                                                                {{ detailNpbu.kodepos }}
                                                            </div>
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Telepon
                                                    </b-td>
                                                    <b-td class="">
                                                        {{ detailNpbu.notelepon }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Handphone
                                                    </b-td>
                                                    <b-td class="">
                                                        {{ detailNpbu.nomp }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Email
                                                    </b-td>
                                                    <b-td class="">
                                                        {{ detailNpbu.email }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No./ Tgl. Registrasi
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.no_registrasi }}
                                                        </div>
                                                        <div v-if="helper.detail">
                                                            {{ helper.detail.tgl_registrasi }}
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <!--  -->
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="p-0">
                                        <b-table-simple bordered small responsive class="m-0">
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td colspan="2" class="font-weight-bold">
                                                        <u>STATUS REGISTRASI BADAN USAHA</u>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        No. Registrasi
                                                    </b-td>
                                                    <b-td class="">
                                                        {{ detailNpbu.no_registrasi }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Tgl. Registrasi
                                                    </b-td>
                                                    <b-td class="">
                                                        {{ detailNpbu.tgl_registrasi }}
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td width="15%" class="">
                                                        Status Registrasi
                                                    </b-td>
                                                    <b-td class="">
                                                        <div v-if="detailNpbu.status_registrasi">
                                                            <h6 v-if="detailNpbu.status_registrasi_id == 5" class="label label-success">
                                                                {{ detailNpbu.status_registrasi.nama }}
                                                            </h6>
                                                            <h6 v-else-if="detailNpbu.status_registrasi_id == 4" class="label label-danger">
                                                                {{ detailNpbu.status_registrasi.nama }}
                                                            </h6>
                                                            <h6 v-if="detailNpbu.status_registrasi_id < 4" class="label label-warning">
                                                                {{ detailNpbu.status_registrasi.nama }}
                                                            </h6>
                                                        </div>
                                                    </b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                    <div class="text-center py-5" v-else>
                        <b-spinner
                            variant="primary"
                            type="grow"
                            label="Spinning"
                        ></b-spinner>
                        <div class="h6 font-weight-bold text-success">
                            Memuat...
                        </div>
                    </div>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab>
                    <template slot="title">
                        <span class="d-sm-none">Tab 2</span>
                        <span class="d-sm-block d-none text-white">IDENTITAS PIMPINAN</span>
                    </template>
                    <div>
                        <b-table-simple bordered small responsive class="m-0">
                            <b-tbody>
                                <b-tr>
                                    <b-td colspan="2" class="font-weight-bold">
                                        <u>IDENTITAS PIMPINAN BADAN USAHA</u>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        NIK
                                    </b-td>
                                    <b-td class="font-weight-bold">
                                        <div v-if="detailNpbu.pimpinan" class="font-weight-bold">
                                            {{ detailNpbu.pimpinan.nik }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Nama
                                    </b-td>
                                    <b-td class="font-weight-bold">
                                        <div v-if="detailNpbu.pimpinan" class="font-weight-bold">
                                            {{ detailNpbu.pimpinan.nama }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Jabatan
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.pimpinan" class="">
                                            {{ detailNpbu.pimpinan.jabatan }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        No. Handphone
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.pimpinan" class="">
                                            {{ detailNpbu.pimpinan.nomp }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Email
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.pimpinan" class="">
                                            {{ detailNpbu.pimpinan.email }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Alamat
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.pimpinan">
                                            {{ detailNpbu.pimpinan.alamat }}
                                        </div>
                                        <div v-if="detailNpbu.pimpinan">
                                            {{ detailNpbu.pimpinan.kodepos }}
                                        </div>
                                        <!-- {{ data.alamat }} -->
                                        <!-- <div v-if="data.wilayah_kelurahan">
                                            Kel. {{ data.wilayah_kelurahan.nama }}<br>
                                            Kec. {{ data.wilayah_kelurahan.wilayah_kecamatan.nama}}<br>
                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.nama }}<br>
                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi.nama }}<br>
                                            {{ data.kodepos }}
                                        </div> -->
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab>
                    <template slot="title">
                        <span class="d-sm-none">Tab 3</span>
                        <span class="d-sm-block d-none text-white">IDENTITAS PENANGGUNG JAWAB</span>
                    </template>
                    <div>
                        <b-table-simple bordered small responsive class="m-0">
                            <b-tbody>
                                <b-tr>
                                    <b-td colspan="2" class="font-weight-bold">
                                        <u>IDENTITAS PENGANGGUNG JAWAB BADAN USAHA</u>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        NIK
                                    </b-td>
                                    <b-td class="font-weight-bold">
                                        <div v-if="detailNpbu.penanggung_jawab" class="font-weight-bold">
                                            {{ detailNpbu.penanggung_jawab.nik }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Nama
                                    </b-td>
                                    <b-td class="font-weight-bold">
                                        <div v-if="detailNpbu.penanggung_jawab" class="font-weight-bold">
                                            {{ detailNpbu.penanggung_jawab.nama }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Jabatan
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.penanggung_jawab" class="">
                                            {{ detailNpbu.penanggung_jawab.jabatan }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        No. Handphone
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.penanggung_jawab" class="">
                                            {{ detailNpbu.penanggung_jawab.nomp }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Email
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.penanggung_jawab" class="">
                                            {{ detailNpbu.penanggung_jawab.email }}
                                        </div>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td width="15%" class="">
                                        Alamat
                                    </b-td>
                                    <b-td class="">
                                        <div v-if="detailNpbu.penanggung_jawab">
                                            {{ detailNpbu.penanggung_jawab.alamat }}
                                        </div>
                                        <div v-if="detailNpbu.penanggung_jawab">
                                            {{ detailNpbu.penanggung_jawab.kodepos }}
                                        </div>
                                        <!-- {{ data.alamat }} -->
                                        <!-- <div v-if="data.wilayah_kelurahan">
                                            Kel. {{ data.wilayah_kelurahan.nama }}<br>
                                            Kec. {{ data.wilayah_kelurahan.wilayah_kecamatan.nama}}<br>
                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.nama }}<br>
                                            {{ data.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi.nama }}<br>
                                            {{ data.kodepos }}
                                        </div> -->
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-tab>
                <!-- end tab -->
            </b-tabs>
            <!-- end nav-tabs -->
        </div>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import PageOptions from "@/config/PageOptions.vue";
import HeaderCard from "@/components/header/HeaderCard.vue";
import npbuMixins from "@/helper/npbu/npbu";

export default {
    mixins: [npbuMixins],
    components: {
        HeaderCard
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem("user")),
            detailNpbu: ""
        };
    },
    created() {
        PageOptions.pageEmpty = false;
        document.body.className = "";
        if (this.user.npbu_id !== null) {
            this.detail(this.user.npbu_id);
        }
    }
};
</script>

<style scoped>
.main:hover .cust-shadow {
    box-shadow: 3px 3px 7px black;
    transition: all 0.5s ease;
    cursor: pointer;
}
</style>
